import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, ElementRef, Renderer2 } from '@angular/core';
import { reloadApp } from '../../core/utils/reload-app';

@Component({
  selector: 'app-confirmation-modal',
  template: `
  <div class="modal" [class.is-deleting]="isDeleting">
    <div class="modal-content">
      <p *ngIf="!isDeleting">{{ confirmMessage }}</p>
      <div class="button-container" *ngIf="!isAlertOnly && !isDeleting">
        <button (click)="onConfirm()">Confirm</button>
        <button (click)="onCancel($event)" style="background-color: #ccc;color:black">Cancel</button>
      </div>
      <div class="button-container" *ngIf="isAlertOnly && !isDeleting">
        <button (click)="onCancel($event)" style="width: 100%;">OK</button>
      </div>
      <div class="deleting-message" *ngIf="isDeleting">
        <div class="spinner"></div>
        <p>{{ deletingMessage || 'Deleting files...' }}</p>
      </div>
    </div>
  </div>
`, styleUrls: ['./confirmation-modal.component.css']
})
export class ConfirmationModalComponent implements OnInit, OnDestroy {

  @Output() confirmed = new EventEmitter<boolean>();
  @Output() cancel = new EventEmitter<boolean>();
  @Input() confirmMessage!: string;
  @Input() isHomePage: boolean = false;
  @Input() isAlertOnly: boolean = false;
  @Input() isDeleting: boolean = false;
  @Input() deletingMessage: string = 'Deleting files...';

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    // console.log(this.confirmMessage); //__CONSOLE_LOG__
    // Move modal to body to escape parent stacking contexts
    const modalElement = this.elementRef.nativeElement;
    this.renderer.appendChild(document.body, modalElement);
  }

  ngOnDestroy() {
    // Remove from body when destroyed
    const modalElement = this.elementRef.nativeElement;
    if (modalElement && modalElement.parentNode === document.body) {
      this.renderer.removeChild(document.body, modalElement);
    }
  }

  onConfirm() {
    this.confirmed.emit(true);
  }

  onCancel(event: Event) {
    // console.log({ event }); //__CONSOLE_LOG__

    if (this.isHomePage) {
      event?.stopPropagation();
      reloadApp('home_confirm', { force: true });
    }
    else {
      //event?.stopPropagation();
      this.confirmed.emit(false);
      this.cancel.emit(false);
    }
  }
}
